import { createFileRoute } from '@tanstack/react-router';
import { ConnectionsTab } from '@/features/integrations';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/overview')({
  component: ConnectionsTab,
});
